import angular from "angular";
import { directiveFactory } from "../../angular-core";

export class StepIfDirective implements ng.IDirective {
    static componentName: string = "stepIf";
    static $inject = ["$animate", "$compile"];

    multiElement = true;
    transclude = "element" as any;
    priority = 600;
    terminal = true;
    restrict = "A";
    $$tlb = true;

    link = (
        $scope: $TSFixMe,
        $element: JQLite,
        $attr: ng.IAttributes,
        ctrl: $TSFixMe,
        $transclude?: ng.ITranscludeFunction
    ) => {
        var block, childScope: $TSFixMe, previousElements;
        $scope.$watch($attr.stepIf, (value: $TSFixMe) => {
            if (value) {
                if (!childScope) {
                    $transclude!((clone: $TSFixMe, newScope: $TSFixMe) => {
                        childScope = newScope;
                        block = {
                            clone: clone
                        };
                        this.$animate.enter(clone, $element.parent(), $element);
                    });
                }
            }
        });
    };

    constructor(protected $animate: $TSFixMe, protected $compile: ng.ICompileService) {}
}

angular.module("topline.directives").directive(StepIfDirective.componentName, directiveFactory(StepIfDirective));
